import React from 'react';
import { Card } from '@/components/ui';
import { Calendar } from 'lucide-react';

export function UpcomingActivities() {
  const tasks = [
    { title: 'Phun thuốc trừ sâu rệp', area: 'Khu A - Vinhomes', time: 'Hôm nay, 16:00', type: 'spray' },
    { title: 'Bón lót NPK định kỳ', area: 'Khu C - Công viên', time: 'Ngày mai, 07:30', type: 'fertilize' },
    { title: 'Đánh giá tỷ lệ sống', area: 'Dự án Cây xanh Đảo', time: '12/05/2024', type: 'evaluate' },
    { title: 'Cắt tỉa tạo tán định kỳ', area: 'Khu B - Phố đi bộ', time: '15/05/2024', type: 'prune' }
  ];

  return (
    <Card className="bg-white border-2 border-slate-100 shadow-sm rounded-md p-5 h-full flex flex-col">
      <div className="flex-1 relative">
        {/* Vertical Line */}
        <div className="absolute top-6 bottom-6 left-[9px] w-[2px] bg-slate-100" />

        <div className="space-y-4 relative z-10">
          {tasks.slice(0, 4).map((task, i) => (
            <div key={i} className="flex items-start gap-4">
              {/* Timeline dot */}
              <div className="flex-shrink-0 mt-3 flex items-center justify-center w-5 h-5 rounded-full bg-white border-[3px] border-emerald-500 shadow-[0_0_0_4px_white]">
              </div>

              {/* Task Card */}
              <div className="flex-1 p-3.5 rounded-xl border border-slate-100 bg-white shadow-sm hover:border-emerald-200 hover:shadow-md transition-all">
                <h4 className="text-sm font-black text-slate-800 mb-1.5">{task.title}</h4>
                <p className="text-xs text-slate-500 mb-2.5">{task.area}</p>
                <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-slate-50 text-slate-500 text-xs font-medium border border-slate-100">
                  <Calendar className="w-3.5 h-3.5 opacity-70" />
                  <span>{task.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
